import {
  faEye,
  faEyeSlash,
  faLock,
  faUserCircle,
  faCaretDown,
  faPlusCircle,
  faCalendarAlt,
  faGlobe,
  faBell,
  faTimesCircle,
  faSearch,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

export default {
  faEye,
  faEyeSlash,
  faLock,
  faUserCircle,
  faCaretDown,
  faPlusCircle,
  faCalendarAlt,
  faGlobe,
  faBell,
  faTimesCircle,
  faSearch,
  faChevronDown,
}
